import React from 'react';
import { ShaderGradientCanvas, ShaderGradient } from '@shadergradient/react';
import './App.css';
import MacWindow from 'components/MacWindow';

function App() {
  return (
    <div className="App">
      {/* ShaderGradient Background */}
      <div className="gradient-container">
        <ShaderGradientCanvas className="shader-canvas">
          <ShaderGradient
            type="plane"
            shader="defaults"
            animate="on"
            uDensity={1.3}
            uStrength={4}
            color1="#ff5005"
            color2="#dbba95"
            color3="#d0bce1"
            grain="on"
            lightType="3d"
            brightness={1.2}
            cDistance={3.6}
            cAzimuthAngle={180}
            cPolarAngle={90}
            positionX={-1.4}
            positionY={0}
            positionZ={0}
            rotationX={0}
            rotationY={10}
            rotationZ={50}
            uSpeed={0.4}
          />
        </ShaderGradientCanvas>
      </div>

      {/* Mac Window UI */}
      <MacWindow />
    </div>
  );
}

export default App;
